// Content for the Commercial & Industrial track home pages.
// Residential keeps its existing dedicated Home.jsx. These drive <TrackHome />.

export const COMMERCIAL_HOME = {
    hero: {
        eyebrow: "Commercial",
        title: "Commercial Exterior & Property Contracting Across the GTA",
        subhead:
            "Reliable, insured, and scheduled exterior & property work for retail, office, multi-residential and mixed-use portfolios — one accountable vendor from quote to sign-off.",
        image: "/images/commercial/commercial-track-hero.4b330f12.webp",
            imageAlt: "Newly poured concrete walkway and sealed wall base along the tenant entrances of a multi-unit commercial plaza",
    },
    trust: [
        "Licensed & Insured",
        "WSIB Compliant",
        "COI Provided",
        "Bondable",
        "Scheduled / After-Hours Work",
        "GTA & Golden Horseshoe",
    ],
    value: {
        eyebrow: "Built for Property Managers & Developers",
        title: "One vendor. Every exterior trade. Documented.",
        intro:
            "Reformity consolidates the exterior trades most property portfolios juggle across five contractors — fencing, asphalt, concrete, hardscape, masonry, and grounds — under a single insured point of contact.",
        points: [
            {
                icon: "ShieldCheck",
                title: "Single point of contact",
                body: "One project manager owns the schedule, the crews, and the documentation across every site.",
            },
            {
                icon: "Award",
                title: "Portfolio pricing",
                body: "Multi-site and multi-trade scopes priced together — predictable budgets across the portfolio.",
            },
            {
                icon: "Clock",
                title: "Fast, documented quotes",
                body: "Site assessment, scoped quote, and COIs turned around quickly so your board or owner can approve fast.",
            },
            {
                icon: "Hammer",
                title: "Minimal tenant disruption",
                body: "Scheduled, phased, and after-hours work that keeps tenants operating and entrances open.",
            },
        ],
    },
    servicesIntro: {
        eyebrow: "Commercial Services",
        title: "Exterior & property work, end to end.",
        body: "From parking lots and walkways to fencing, masonry restoration and grounds — scoped for owners, developers and property managers.",
    },
    cta: {
        title: "Get a scoped commercial quote — fast.",
        body: "Tell us about your property or portfolio. We respond within one business day with next steps and the documentation you need.",
    },
};

export const INDUSTRIAL_HOME = {
    hero: {
        eyebrow: "Industrial",
        title: "Industrial Site & Facility Contracting in the GTA",
        subhead:
            "Heavy-duty, durable, and compliant exterior and site work for warehouses, distribution centres, plants and yards — engineered for load, scheduled around your operations.",
        image: "/images/industrial/industrial-track-hero.ddc2fc82.webp",
            imageAlt: "Wide drive aisle beside a multi-unit industrial building with parking under clear blue sky",
    },
    trust: [
        "Licensed & Insured",
        "WSIB Compliant",
        "COI Provided",
        "Health & Safety Compliant",
        "Heavy-Duty Materials",
        "Minimal-Downtime Scheduling",
    ],
    value: {
        eyebrow: "Built for Facility & Asset Managers",
        title: "Engineered for load. Documented for compliance.",
        intro:
            "Industrial sites punish shortcuts. We specify materials and build details for truck and equipment loads, and document the safety and compliance paperwork your facility needs on file.",
        points: [
            {
                icon: "Hammer",
                title: "Durability & load ratings",
                body: "Truck-rated asphalt, heavy slabs, and structures specified for the loads your site actually carries.",
            },
            {
                icon: "ShieldCheck",
                title: "Safety & compliance docs",
                body: "WSIB, COIs, and health-&-safety documentation provided and kept on file for your records.",
            },
            {
                icon: "Award",
                title: "Site security & scale",
                body: "Security fencing, controlled-access gates, bollards, and large-lot capability for full sites.",
            },
            {
                icon: "Clock",
                title: "Scheduling around operations",
                body: "Phased and off-shift work that keeps 24/7 operations, shipping, and yard traffic moving.",
            },
        ],
    },
    servicesIntro: {
        eyebrow: "Industrial Services",
        title: "Heavy-duty site & facility work.",
        body: "Paving, concrete, security fencing, structural masonry, retaining structures, bollards and drainage — built for industrial loads and compliance.",
    },
    cta: {
        title: "Specify your industrial scope with us.",
        body: "Send us your site and requirements. We respond within one business day with an engineered scope, quote, and the compliance documentation you need.",
    },
};

export const TRACK_HOME_CONTENT = {
    commercial: COMMERCIAL_HOME,
    industrial: INDUSTRIAL_HOME,
};
